const previewEditorDialogConstantEN = {
  previewEditorDialogTitle: 'Preview',
};

export default previewEditorDialogConstantEN;
